let switch_booking_mode = function( $ ) {

	let $links;

	let init = function() {
		$links = $( '.switch-booking-mode' ).not( '.setup-link' );

		if ( $links.length > 0 ) {
			_setup_links();
		}
	};

	let _setup_links = function() {
		$links.on( 'click', function( e ) {
			e.preventDefault();

			let mode = $( this ).data( 'mode' ) ? $( this ).data( 'mode' ) : false;

			_change_booking_mode( mode );
		} );

		$links.addClass( 'setup-link' );
	};

	let _change_booking_mode = function( mode = false ) {
		let data = {
			nonce: ScriptData.crate_user_change_booking_mode_nonce,
			action: 'crate_user_change_booking_mode',
		};

		if ( mode ) {
			data.mode = mode;
		}

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			window.location.reload(); // Refresh after change
		} );
	};

	$( document ).ready( init );

	return {
		init: init
	}

} ( jQuery );

module.exports = switch_booking_mode;